import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('FETCH_PINWHEEL_AB_TEST');
export const fetchPinwheelABTest = dataModuleActions.dataRequest;
export const replacePinwheelABTest = dataModuleActions.dataSuccess;
export const fetchPinwheelABTestError = dataModuleActions.dataError;
export const resetPinwheelABTest = dataModuleActions.dataReset;
